import axios from 'axios';
import {Actions, ComparisonSourceTypes, InputTypes,backendServerURLone} from "./store";
import {Base64} from "../helpers/Base64";

const _clientId = Base64.encode('clientId');

const backendServerURL =backendServerURLone;
//`http://${serverAddress}`; //zmiana serwera
/*let ws;
const serverAddress = 'dev2.inspirationvibes.com';'apps.jsa.poprawaprac.pl''';//'api-new-jsa.poprawaprac.pl''localhost:8000';
 const setupWsConnection = ({transactionId, inProgress}) => dispatch => {
  ws = new WebSocket(`wss://${serverAddress}:3000`);
  
  ws.onopen = function open() {
    console.log('connected');
    inProgress && checkProgress({transactionId});
  };
  
  ws.onclose = function close() {
    console.log('disconnected');
  };
  
  ws.onmessage = e => {
    try {
      const msg = JSON.parse(e.data);
      const {type, message, status} = msg;
      if (type === 'msg') {
        console.log(message)
      } else if (type === 'status') {
        console.log(status);
        switch (status) {
          case 'ready':
            getReport({transactionId})(dispatch);
            break;
            
          case 'inProgress':
            checkProgress({transactionId});
            break;
    
          case 'notFound':
            dispatch({
              type: Actions.UPDATE_PROGRESS,
              payload: false
            })
            break;
    
          default:
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
}
*/
// export const checkProgress = ({transactionId}) => {
//   setTimeout(() => {
//     ws.send(JSON.stringify({
//       transactionId,
//       task: 'checkStatus'
//     }));
//   }, 30000);
// }
//sprawdzenie czy funkcja przerobila plagiat
export const showBackgroundvideo = () => dispatch => {
  
     
      dispatch({
          type: Actions.Show_Backgroundvideo,
          payload:true
      });
  }

export const checkProgress = ({transactionId, tryDemo, clientId, timeout = 0}) => dispatch => {
 
  
  console.log('powrot z bankuchec status');

  setTimeout(() => {
    axios.get(`${backendServerURL}/checkComparisonStatus`, {
      params: {transactionId, tryDemo, 'Y2xpZW50SWQ=': clientId}
    }).then(({data}) => {
      switch (data) {
        case 'inProgress':       
          checkProgress({transactionId,  tryDemo, clientId, timeout: 30000})(dispatch);
          break;
          
        case 'ready':
          getReport({transactionId, tryDemo, clientId})(dispatch);
          break;
          
        default:
      }
    }, () => {
      dispatch({
        type: Actions.UPDATE_PROGRESS,
        payload: false,
        
      })
    });
  }, timeout);
}
//ladowanie wyniku porownania
export const getReport = ({transactionId, tryDemo, clientId }) => dispatch => {
  console.log('progre1');
  dispatch({
    type: Actions.UPDATE_PROGRESS,
     payload: false
   });
  
  axios.get(`${backendServerURL}/getReport`, {
    params: {transactionId, tryDemo, 'Y2xpZW50SWQ=': clientId}
  }).then(({data}) => {
    console.log('load1');
    dispatch({
      type: Actions.LOAD_COMPARISON_RESULT,
      payload: {
        report: data,
        tryDemo,
        processing: false,
        inProgress: false
      }
    })
  }, err => {
    console.log(err);
  })
  
}

export const verifyClient = () => async (dispatch, getState) => {
  const {clientId, transactionId, inProgress, tryDemo, adminId, selectedOnly} = getState();
  //setupWsConnection({clientId, transactionId, inProgress})(dispatch);
  const ip=await fetch("https://api.ipify.org").then(res=>res.text()).then(ip=>{console.log(ip)
return ip})

  inProgress && checkProgress({transactionId, clientId, tryDemo})(dispatch);
  dispatch({
    type: Actions.UPDATE_PROCESSING,
    payload: {
      processing: true
     
    }
  });
  axios.get(`${backendServerURL}/verifyClient`, {
    params: {
      'Y2xpZW50SWQ=': clientId,
      transactionId,
      adminId,
      selectedOnly,
      ip: ip
    }
  }).then(({data}) => {
    if (!data.demoAvailable) {
     //usuniecie mozliwosc testu      
     //localStorage.removeItem('tryDemo');
    }
    dispatch({
      type: Actions.VERIFY_CLIENT,
      payload: {
        ...data,
        processing: false,
        
      }
    });
  }, err => {
    dispatch({
      type: Actions.UPDATE_PROCESSING,
      payload: {
        processing: false

      }
    });
    console.log(err);
  });
};
// zmiana w polach importu
export const updateSource = ({inputType, content, sourceType, file}) => (dispatch, getState) => {
  dispatch({
    type: Actions.UPDATE_SOURCE,
    payload: {
      inputType,
      ...file && {
        filename: file.name,
        processing: false
      },
      content,
      sourceType,
    }
  });
  //wstawione dwa pliki
  if (inputType === InputTypes.FILE && file) {
    const data = new FormData();
    const {clientId, selectedOnly} = getState();
    data.append('sourceType', sourceType);
    data.append(_clientId, clientId);
    data.append('file', file);
    if (sourceType === ComparisonSourceTypes.ORIGINAL) {
      data.append('selectedOnly', selectedOnly);
    }
    //pobranie danych z serwera
    console.log(data);
    axios.post(`${backendServerURL}/uploadForComparison`, data)
    .then(({data, status}) => {
      if (status === 200) {
        dispatch({
          type: Actions.UPDATE_SOURCE,
          payload: {
            sourceType,
            inputType,
            ...data,
            processing: false
          }
        });
      }
    }, err => {
      dispatch({
        type: Actions.UPDATE_PROCESSING,
        payload: {
          processing: false
        }
      });
     
      console.log(err);
    });
  }
}

export const compare = ({tryDemo = false}) => (dispatch, getState) => {
  const {originalSource, userSource, clientId, transactionId, adminId, selectedOnly, wrongEmail, email,compareview, sendByEmailJSA} = getState();
  if (!sendByEmailJSA && !window.confirm('Nie podałeś adresu e-mail, na który ma zostać wysłany raport. Jeśli zamkniesz okno przeglądarki podczas analizy tekstu, utracisz możliwość natychmiastowego uzyskania wyniku porównania. W takiej sytuacji raport zostanie Ci udostępniony po kontakcie z administratorem strony.')) {
    return;
  }
  dispatch({
    type: Actions.UPDATE_PROCESSING,
    payload: {
      processing: true,
      tryDemo
    }
  });
  localStorage.setItem('tryDemo', tryDemo);  //ustawienie do local storage dema
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('tid');
  const searchParamsString = searchParams.toString();
  //pobieranie danych
  axios.post(`${backendServerURL}/compareSources`, {
    ...originalSource.inputType && {
      ...originalSource.inputType === InputTypes.TEXT && {
        originalContent: originalSource.content
      },
      ...originalSource.inputType === InputTypes.FILE && originalSource.isJSAReport && {
        selectedOnly
      }
    },
    ...userSource.inputType && userSource.inputType === InputTypes.TEXT && {
      userContent: userSource.content
    },
    [_clientId]: clientId,
    transactionId,
    adminId,
    tryDemo,
    returnUrlSuccess: window.location.origin + window.location.pathname + (searchParamsString ? `?${searchParamsString}` : ''),
    ...sendByEmailJSA && !wrongEmail ? {email, sendByEmailJSA} : {}
  }).then(({data}) => {
    const {url, report, inProgress, transactionId} = data;
    if (url) {
      window.location.replace(url);
      return;
    }
  
    if (transactionId) {
      searchParams.set('tid', transactionId);
      
    window.location.replace(window.location.origin + window.location.pathname + `?${searchParams.toString()}`);
    }
    console.log('load2');
    dispatch({
      type: Actions.LOAD_COMPARISON_RESULT,
      payload: {
        report,
        tryDemo,
        processing: false,
        inProgress,
        transactionId,
        compareview
        
      }
    });
  }, err => {
    dispatch({
      type: Actions.UPDATE_PROCESSING,
      payload: {
        processing: false
      }
    });
    console.log(err);
  });
}
//ponowne porownanie i generowanie raportu pdf (axios)tekstu  dodanie removeItem

export const getComparisonPdf = () => (dispatch, getState) => {

  const {transactionId, clientId, tryDemo} = getState();
  dispatch({
    type: Actions.UPDATE_PROCESSING,
    payload: {
      processing: true,
      
    }
    
  });
  axios.get(`${backendServerURL}/getComparisonPdf`, {
    params: {
      'Y2xpZW50SWQ=': clientId,
      transactionId,
      tryDemo
    },
    responseType: 'blob'
  }).then(({data, headers}) => {
    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    const contentDisposition = headers["content-disposition"];
    const filename = contentDisposition ? contentDisposition.split('filename="')[1].replace('"', '') : 'comparison_report.pdf'
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    tryDemo && dispatch({type: Actions.DEMO_USED});
    setTimeout(() => {
      dispatch({
        type: Actions.UPDATE_PROCESSING,
        payload: {
          processing: false
        }
      });
    }, 1)
  })
}
//pobieranie rapotu dodanie try 

export const DownloadPdf = (data) => (dispatch, getState) => {
  //tryb arhiwum
  let pathpdf='';
  let moht;
  let day;
  let isdemopdf=false;
  const gotonewcompare=data.gotonewcompare;
  let isdownloandforclient=data.isdownloandforclient;
  if(isdownloandforclient){
  let path='';
   day =data.day;
   moht =data.moht;
  const isdemopdf =data.isdemopdf;
  const idpdf =data.idpdf;
  if(!isdemopdf){
  pathpdf=day+'.'+moht+'/'+idpdf+'.pdf';
  }else{
    pathpdf='_demo_/'+day+'.'+moht+'/'+idpdf+'.pdf';
  }
  console.log(`pobieranie${path}`);
  }else{
    let d = new Date();
   moht = d.getMonth()+1;
   day = d.getDate();console.log(`tryb niearchiwalny`);
   const {transactionId} = getState();
 
    isdownloandforclient= false;
    if(transactionId === null)
    { const {clientId} = getState();
      pathpdf=`${clientId}.pdf` ;
      isdemopdf=true;}
    else{pathpdf=`${transactionId}.pdf` ;}}

  /*
  
 
  const {transactionId} = getState();
 
 let isdownloandforclient= false;
  if(transactionId === null)
  { const {clientId} = getState();
    pathpdf=`${clientId}.pdf` ;
    isdemopdf=true;}
  else{pathpdf=`${transactionId}.pdf` ;}
 if(!isdownloandforclient)
 { 
 }
  */
 
  axios.get(`${backendServerURL}/download`, {
    params: {
      day:day,
      moht:moht,
      pathpdf:pathpdf,
      isdemopdf,
      isdownloandforclient
    },
    responseType: 'blob'
  }).then(({data, headers}) => {
    console.log(data);
    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    const contentDisposition = headers["content-disposition"];
    const filename = contentDisposition ? contentDisposition.split('filename="')[1].replace('"', '') : 'comparison_report.pdf'
    link.setAttribute('download', filename);
    
    document.body.appendChild(link);
    link.click();
    link.remove();
   
    console.log(gotonewcompare);
    if(gotonewcompare===1)
    { const {adminId} = getState();
    const {pathreturnpage}=getState();
    const {isAdmin} = getState();
      let path=pathreturnpage;
  const link = document.createElement('a');
  console.log(isAdmin);
  if(adminId&&isAdmin){
    console.log(adminId);
    path=path+`/?adminId=${adminId}`;
  }
  link.href = path
  console.log(path);
  console.log('klikniety powrot');
 
  link.click();

    }
   //tryDemo && dispatch({type: Actions.DEMO_USED});
    setTimeout(() => {
      dispatch({
        type: Actions.UPDATE_PROCESSING,
        payload: {
          processing: false

        }
      });
    }, 1)
  })
}

// akceptacja regulaminu 
export const acceptTerms = accept => dispatch => {
  localStorage.setItem('acceptTerms', `${accept}`);
  dispatch({
    type: Actions.ACCEPT_TERMS,
    payload: accept
  })
}
//wpisanie emaila wysyłki
export const setsendByEmailJSA = sendByEmailJSA => dispatch => {
  localStorage.setItem('sendByEmailJSA', `${sendByEmailJSA}`);
  dispatch({
    type: Actions.SET_SEND_BY_EMAIL,
    payload: sendByEmailJSA
  })
}
// wpisanie emaila
export const setEmail = ({email}) => dispatch => {
  localStorage.setItem('email', email.trim());
  dispatch({
    type: Actions.SET_EMAIL,
    payload: email.trim()
  })
}
// do sprawdzenia
export const setSelectedOnly = selectedOnly => (dispatch, getState) => {
  const {clientId} = getState();
  dispatch({
    type: Actions.UPDATE_PROCESSING,
    payload: {
      processing: false
    }
  });
  axios.post(`${backendServerURL}/getUpdatedWordCount`, {
    selectedOnly,
    [_clientId]: clientId
  }).then(({data}) => {
    localStorage.setItem('selectedOnly', `${selectedOnly}`);
    dispatch({
      type: Actions.MARK_SELECTED_ONLY,
      payload: {
        selectedOnly,
        ...data
      }
    })
  })
}
//nieużywane chyba
export const askForDonation = () => dispatch => {
  let donate = false;
  setTimeout(() => {
    if (window.confirm("Wesprzyj rozwój programu! Dla przyszłych roczników.\nWpłać dowolną kwotę, a my przeznaczymy ją na dalszy rozwój systemu.")) {
      donate = true;
    }
    dispatch({
      type: Actions.SET_DONATION,
      payload: {donate}
    })
  }, 3000);
}
//nieużywane chyba
export const setDonationAmount = donationAmount => dispatch => {
  dispatch({
    type: Actions.SET_DONATION_AMOUNT,
    payload: {donationAmount}
  })
}
//nieużywane chyba
export const makeDonation = ({email, amount}) => {
  axios.post(`${backendServerURL}/donate`, {
    email,
    amount,
    returnUrlSuccess: window.location.origin + window.location.pathname + '/thank-you'
  }).then(({data}) => {
    const {url} = data;
    if (url) {
      window.location.replace(url);
    }
  })
}
